<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="form.title"
          name="name"
          :readonly="readonly"
          :counter="65"
          :rules="rules.title"
          :error-messages="errors.title"
          :label="`${$t('ITEM.TITLE')} *`"
          @input="updateValue('title', $event)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col md="8" xs="12">
        <v-card outlined height="150">
          <v-card-text>
            <language-tabs
              v-if="form"
              ref="languageTabs"
              v-model="form.translations"
              :errors="errors.translations"
              #default="{ translation, index, language, on, ...other }"
              eager
            >
              <abo-service-translation-form
                :value="translation"
                :language-id="language.id"
                :readonly="readonly"
                v-bind="other"
                v-on="on"
                @update-prop="updateValue($event, `translations.${index}`)"
                @valid="setValid(`translations.${index}`, $event)"
              />
            </language-tabs>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4" xs="12">
        <v-card flat>
          <v-card-text>
            <v-form>
              <v-row>
                <v-col cols="8">
                  <v-subheader>
                    <div>
                      <span class="text-body-2">
                        {{ $t('PERSONS.STATUS') }}:</span
                      >
                    </div>
                    <div>
                      <v-select
                        v-model="form.status_id"
                        name="status_id"
                        :error="errors.status_id"
                        :items="statuses"
                        :loading="!!!statuses.length"
                        :readonly="readonly"
                        :rules="rules.status"
                        class="pr-2"
                        flat
                        solo
                        small-chips
                        hide-details
                        dense
                        item-text="name"
                        item-value="id"
                        style="width: 130px"
                        @change="updateValue('status_id', $event)"
                      >
                        <template
                          v-slot:selection="{ attrs, item, select, selected }"
                        >
                          <v-chip
                            small
                            :color="item.color"
                            dark
                            class="ml-1"
                            v-bind="attrs"
                            :input-value="selected"
                            @click="select"
                          >
                            {{ item.name }}
                          </v-chip>
                        </template>
                      </v-select>
                    </div>
                  </v-subheader>
                </v-col>
                <v-col cols="8">
                  <v-select
                    v-model="form.type_id"
                    name="type_id"
                    item-value="id"
                    item-text="name"
                    :items="typesList"
                    :rules="rules.type"
                    :disabled="!isCreate"
                    :readonly="readonly"
                    :label="`${$t('ITEM.TYPE')} *`"
                    :error-messages="errors.type_id"
                    @change="updateValue('type_id', $event)"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <slot name="buttons" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import formEditable from '@/modules/_global/mixins/form-editable';
import AboServiceTranslationForm from '@/modules/abo_services/components/forms/AboServiceTranslationForm';
import { maxLength, notEmpty } from '@/modules/_global/variables/rules';
import { AboServicesService } from '@/services/abo-services.service';

export default {
  name: 'AboServicesForm',

  components: {
    AboServiceTranslationForm,

    LanguageTabs: () => import('@/modules/_global/_components/LanguageTabs')
  },

  mixins: [formEditable],

  data: () => {
    return {
      statuses: [],
      form: {
        translations: [],
        status_id: null,
        title: null
      },
      typesList: [
        {
          id: 'b-customer',
          name: 'B-Customer'
        },
        {
          id: 'c-customer',
          name: 'C-Customer'
        }
      ],
      rules: {
        status: [notEmpty],
        type: [notEmpty],
        title: [notEmpty, maxLength(65)]
      }
    };
  },

  created() {
    AboServicesService.getStatuses()
      .then(data => (this.statuses = data.data.data))
      .then(() => {
        if (!this.form.status_id) {
          this.form.status_id = this.statuses.find(Boolean).id;
        }
      });
  },

  methods: {
    setValid(index, value) {
      this.$emit('setValid', index, value);
    }
  }
};
</script>

<style scoped></style>
